<!--  Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved. -->

<template>
	<snackbar-status v-if="ifToast" :success="ifSuccessful">
		<div class="snackbar">
			<icon-comp v-if="toast.icon" :icon="toast.icon" class="snackbar__icon"></icon-comp>
			<div class="snackbar__textBox">
				<span class="snackbar__text">
					{{ toast.text }}
				</span>
				<span v-if="toast.files" class="snackbar__files">
					{{ toast.files }}
				</span>
			</div>
			<button @click="removeToast()">
				<icon-comp
					icon="close_medium"
					label="Close Snackbar"
					class="snackbar__icon"
				></icon-comp>
			</button>
		</div>
	</snackbar-status>
</template>

<script>
import { mutationTypes } from '@/store';
import { mapMutations, mapState } from 'vuex';
import SnackbarStatus from '@/components/SnackbarStatus.vue';
import { IconComp } from '@protolabs/component-library';

export default {
	name: 'notifications-comp',
	components: {
		SnackbarStatus,
		IconComp,
	},
	computed: {
		...mapState({
			toast: (state) => state.toast,
		}),
		ifToast() {
			return Object.keys(this.toast).length !== 0;
		},
		ifSuccessful() {
			return this.toast.color === 'green';
		},
	},
	methods: {
		...mapMutations({
			setToast: mutationTypes.SET_TOAST,
		}),
		removeToast() {
			this.setToast({});
		},
	},
};
</script>

<style lang="scss">
.snackbar {
	display: flex;
	justify-content: center;
	align-items: center;

	&__textBox {
		display: flex;
		flex-direction: column;
		margin: 0px 10px;
		align-items: center;
	}

	&__text {
		@include font-header-book-h3;
		text-align: center;
	}

	&__files {
		@include font-body-book-regular;
	}

	&__icon {
		& svg {
			& * {
				fill: white !important;
			}
		}
	}
}

.v-snack__wrapper {
	max-width: 900px !important;
}

.v-snack__content {
	padding: 15px !important;
}
</style>
